import {
  createContext,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react';

export type MapToolMode =
  | 'pan'
  | 'select'
  | 'create_barrier'
  | 'pick_direction_hint'
  | 'add_waypoint'
  | 'create_route'
  | 'pick_route_origin'
  | 'pick_route_destination';

interface MapToolValue {
  readonly mode: MapToolMode;
  readonly setMode: (next: MapToolMode) => void;
}

const MapToolContext = createContext<MapToolValue | undefined>(undefined);

const DEFAULT_MODE: MapToolMode = 'pan';

interface MapToolProviderProps {
  readonly children: ReactNode;
}

export function MapToolProvider({ children }: MapToolProviderProps) {
  const [mode, setMode] = useState<MapToolMode>(DEFAULT_MODE);

  const value = useMemo<MapToolValue>(
    () => ({ mode, setMode }),
    [mode],
  );

  return <MapToolContext.Provider value={value}>{children}</MapToolContext.Provider>;
}

export function useMapTool(): MapToolValue {
  const ctx = useContext(MapToolContext);
  if (!ctx) {
    throw new Error('useMapTool must be used within MapToolProvider');
  }
  return ctx;
}
